(() => {

  const footer = document.querySelector('.kt-main-footer');
  if (!footer) return;

  const isFixed = document.body.classList.contains('kt-main-footer--is-fixed');

  const updateFooter = () => {
    const footerHeight = footer.offsetHeight;
    document.body.style.setProperty('--footer-height', `${footerHeight}px`);
    if (isFixed) {
      document.body.classList.toggle('kt-main-footer--is-taller', window.innerHeight < footerHeight);
    }
  };

  new ResizeObserver(updateFooter).observe(footer);

  if (isFixed) {
    window.addEventListener('resize', debounce(updateFooter, 100));

    const footerInner = footer.querySelector('.kt-main-footer__inner');
    if (footerInner) {
      const parallaxOffset = 25;
      KROWN.functions.observeScrollProgress(document.body, () => {
        if (document.body.classList.contains('kt-main-footer--is-taller')) {
          footerInner.style.transform = '';
          return;
        }
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (maxScroll <= 0) {
          footerInner.style.transform = '';
          return;
        }
        const footerH = footer.offsetHeight;
        const revealStart = maxScroll - footerH;
        const progress = Math.min(1, Math.max(0, (window.scrollY - revealStart) / footerH));
        footerInner.style.transform = `translateY(${parallaxOffset * (1 - progress)}%)`;
      }, 'cover');
    }
  }

})();